// ratings => {1: 12, 2: 3, 4: 5, 5: 7}
const computeRating = (ratings = {}) => {
  const demoninator = Object.values(ratings).reduce((acc, curr) => acc + curr, 0)
  const numerator = Object.entries(ratings).reduce((acc, [key, value]) => acc + (key * value), 0)

  const rating =  demoninator > 0 ? (numerator / demoninator).toFixed(1) : 0

  return [rating, demoninator]
}

export default computeRating